export const PROVINCE = {
  value: "PROVINCE",
  key: "clients.client.reports.coverageCertificate.form.type.province",
};
export const DIVISION = {
  value: "DIVISION",
  key: "clients.client.reports.coverageCertificate.form.type.division",
};

export default [PROVINCE, DIVISION];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/reports/enums/coverageCertificateTypes.js